<template>
  <div>
    <div id="overlay"  v-if="loading">
      <div class="spinner"></div>
      <br/>
        <h4>Loading...</h4>
    </div>
      <form>
        <div class="p-grid">
          <div class="p-col">
            <Button class="p-button p-component p-button-success addNewBtn"  @click.prevent="openBasic" icon="pi pi-plus" label="NEW" />
          </div>
        </div>
        <Dialog header="Bank Account" :modal="true" :visible.sync="displayBasic" :style="{width: '60vw'}" :closable=false
        :contentStyle="{'overflow': 'visible'}">

        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
              <label for="name" >Name<span style="color:red">*</span></label>
              <InputText id="name" v-model.trim="name"/>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="accountNo" >Account No</label>
              <InputText v-model.trim="accountNo" id="accountNo"/>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="branch">Branch</label>
              <InputText v-model.trim="branch" id="branch"/>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="openingBalance">Account Type</label>
              <select class="form-control" v-model="type" @change="selectDrCrType">
                <option selected  value="">Select Type</option>
                <option v-for="(type,ind) in accountTypeList" :key="ind">{{type.type}}</option>
              </select>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="openingBalance">Opening Balance</label>
              <InputText @keypress="isNumber($event)" v-model.number="openingBalance" id="openingBalance"/>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="accountType">Dr/Cr Type</label>
              <select class="form-control" v-model="openingDrCr" id="accountType">
                <option selected  value="">Select Dr/Cr</option>
                <option  v-for="(drcr,ind) in dr_crList" :key="ind">{{drcr.openingDrCr}}</option>
              </select>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="openingBalance" >Status</label>
               <div class="p-field p-col-12 p-md-6">
                <RadioButton id="city1" name="ACTIVE" value="ACTIVE" v-model="status" />
                <label for="city1">Active</label>
                <RadioButton id="city1" name="INACTIVE" value="INACTIVE" v-model="status" />
                <label for="city1">Inactive</label>
              </div>
            </div>
        </div>
        <template #footer>
           <Button class="p-button-raised p-button-rounded" @click.prevent="addBank" :label="editing?'Update':'Add'"/>
          <Button class="p-button-raised p-button-primary" label="Add & New" @click.prevent="addAndNewBank" v-if="!editing"/>
          <Button @click.prevent="cancel" class="p-button-raised p-button-danger" label="Cancel"/>
        </template>
       </Dialog>
      </form>
  </div>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import InputMask from 'primevue/inputmask'
import Dialog from 'primevue/dialog'
import RadioButton from 'primevue/radiobutton'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
export default {
  name: 'bank',
  data() {
    return {
      name: '',
      branch: '',
      accountNo: '',
      type: '',
      openDate: '',
      dialogShow: false,
      editing: false,
      openingBalance: '',
      status: 'ACTIVE',
      accountTypeList: [
        {'type': 'Fixed'},
        {'type': 'Saving'},
        {'type': 'Over Draft'}
      ],
      dr_crList: [
        {'openingDrCr': 'Dr'},
        {'openingDrCr': 'Cr'}
      ],
      openingDrCr: '',
      displayBasic: false,
      loading: false
    }
  },
  methods: {
    async addBank() {
      let resp = ''
      if (this.name.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Bank name cannot be empty!', life: 10000})
        return
      }
      let bank = {
        name: this.name,
        branch: this.branch,
        openingDate: this.openDate,
        type: this.type,
        accountNumber: this.accountNo,
        openingBalance: this.openingBalance,
        openingDrCr: this.openingDrCr,
        id: this.id,
        status: this.status
      }
      if (!this.editing) {
        this.loading = !this.loading
        resp = await this.$store.dispatch('createBankDetail', bank)
        this.loading = false
      } else {
        this.loading = !this.loading
        resp = await this.$store.dispatch('updateBankDetail', bank)
        this.loading = false
      }
      this.responseMessage(resp)
      this.closeBasic()
    },
    async addAndNewBank() {
      let resp = ''
      if (this.name.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Bank name cannot be empty!', life: 10000})
        return
      }
      let bank = {
        name: this.name,
        branch: this.branch,
        openingDate: this.openDate,
        type: this.type,
        accountNumber: this.accountNo,
        openingBalance: this.openingBalance,
        openingDrCr: this.openingDrCr,
        status: this.status
      }
      this.loading = !this.loading
      resp = await this.$store.dispatch('createBankDetail', bank)
      this.loading = false
      this.responseMessage(resp)
    },
    responseMessage(resp) {
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.reset()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      }
    },
    cancel() {
      this.error = false
      this.message = ''
      this.messageType = ''
      this.closeBasic()
      this.editing = false
      this.reset()
    },
    editBank(data) {
      this.editing = true
      this.name = data.name
      this.accountNo = data.accountNumber
      this.branch = data.branch
      this.type = data.type
      this.status = data.status
      this.openingBalance = data.openingBalance
      this.openingDrCr = data.openingDrCr
      this.id = data.accountMasterId
      if (this.status === undefined) {
        this.status = 'ACTIVE'
      }
      this.openBasic()
    },
    reset() {
      this.name = ''
      this.type = ''
      this.accountNo = ''
      this.openDate = ''
      this.openingBalance = ''
      this.openingDrCr = ''
      this.branch = ''
      this.bank = {}
      this.editing = false
    },
    isNumber(evt) {
      evt = window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    deleteMessage(value) {
      this.$toast.add({severity: value.messageType, summary: '', detail: value.message, life: 10000})
    },
    openBasic() {
      this.displayBasic = true
    },
    closeBasic() {
      this.displayBasic = false
    },
    selectDrCrType(event) {
      if (this.type === 'Over Draft') {
        this.openingDrCr = 'Cr'
      } else if (this.type === 'Fixed' || this.type === 'Saving') {
        this.openingDrCr = 'Dr'
      }
    }
  },
  mounted() {
    this.selectDrCrType()
  },
  components: {
    Dropdown,
    InputMask,
    Dialog,
    RadioButton,
    InputText,
    Button
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// BankAccountDialog.vue?46b104ac